export default __webpack_public_path__ + "static/media/dashboard-light-background.598a089c.jpg";